module.exports = __webpack_public_path__ + "static/media/ztreer.cd88cb88.jpg";